import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { setupTwoFactor, verifyTwoFactorSetup } from '../../services/auth_service/auth_service';
import { message } from 'antd';



const TwoFactorSetupModal = ({ show, handleClose, onSuccess }) => {
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [otp, setOtp] = useState('');
    const [loadingSetup, setLoadingSetup] = useState(false);
    const [loadingVerify, setLoadingVerify] = useState(false);
    const [error, setError] = useState('');

    // Llama a setupTwoFactor para generar el QR code
    const handleSetup = async () => {
        setLoadingSetup(true);
        setError('');
        try {
            const data = await setupTwoFactor(); // Usando la función del servicio
            setQrCodeUrl(data.qrCodeUrl);
        } catch (err) {
            setError(err.message || 'Error al configurar 2FA');
        } finally {
            setLoadingSetup(false);
        }
    };

    // Llama a verifyTwoFactorSetup para verificar el OTP
    // Dentro de tu componente LoginBodecom o el modal de 2FA, en el handleVerify:
    const handleVerify = async (e) => {
        e.preventDefault();
        setLoadingVerify(true);
        setError('');
        try {
            const data = await verifyTwoFactorSetup(otp); // Usando la función del servicio
            // Muestra un mensaje de éxito con Ant Design
            message.success(data.message, 5);
            // Llama a onSuccess sin enviar el mensaje, para evitar duplicación
            onSuccess();
            handleClose(); // Cierra el modal
        } catch (err) {
            // Extrae el mensaje de error de la respuesta si existe
            const errorMsg = err.response?.data?.error || err.message || 'Error al verificar el código OTP';
            message.error(errorMsg, 5);
            setError(errorMsg);
        } finally {
            setLoadingVerify(false);
        }
    };


    // Ejecuta handleSetup al abrir el modal
    useEffect(() => {

        if (show) {
            handleSetup();
        }
    }, [show]);

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Activar Autenticación de Dos Factores</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loadingSetup ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status" />
                        <p>Generando código QR...</p>
                    </div>
                ) : (
                    <>
                        {qrCodeUrl ? (
                            <div className="text-center mb-3">
                                <img src={qrCodeUrl} alt="QR Code 2FA" style={{ maxWidth: '100%' }} />
                                <p>Escanee este código QR con su aplicación autenticadora (Google Authenticator, Authy, etc.).</p>
                            </div>
                        ) : (
                            <Alert variant="warning">No se pudo generar el QR code.</Alert>
                        )}
                        <Form onSubmit={handleVerify}>
                            <Form.Group controlId="formOtp">
                                <Form.Label>Ingrese el código OTP</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="Código OTP"
                                    required
                                />
                            </Form.Group>
                            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                            <Button variant="primary" type="submit" className="mt-3" disabled={loadingVerify}>
                                {loadingVerify ? 'Verificando...' : 'Verificar código'}
                            </Button>
                        </Form>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loadingSetup || loadingVerify}>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TwoFactorSetupModal;
